class ProductRecommendations extends HTMLElement {
  connectedCallback() { this.initialize(); }
  disconnectedCallback() { this.resizeObserver?.disconnect(); this.abort?.abort(); this.track = null; }
  initialize() {
    const track = this.querySelector('[data-rec-track]');
    if (!track || this.track === track) return;
    this.track = track;
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.prev = this.querySelector('[data-rec-prev]');
    this.next = this.querySelector('[data-rec-next]');
    this.dots = this.querySelector('[data-rec-dots]');
    this.prev.addEventListener('click',()=>this.move(-1), options);
    this.next.addEventListener('click',()=>this.move(1), options);
    track.addEventListener('scroll',()=>this.update(), {...options,passive:true});
    track.addEventListener('dragstart',event=>event.preventDefault(), options);
    let pointerStart = null, dragged = false;
    track.addEventListener('pointerdown',event=>{
      pointerStart = {x:event.clientX,y:event.clientY}; dragged = false;
    }, {...options,passive:true});
    track.addEventListener('pointermove',event=>{
      if(pointerStart && Math.hypot(event.clientX-pointerStart.x,event.clientY-pointerStart.y)>8) dragged = true;
    }, {...options,passive:true});
    track.addEventListener('click',event=>{
      if(dragged) { event.preventDefault(); event.stopPropagation(); }
      pointerStart = null;
    }, {...options,capture:true});
    track.addEventListener('keydown',event=>{
      if(event.target!==track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); this.move(event.key==='ArrowRight'?1:-1);
    }, options);
    this.resizeObserver = new ResizeObserver(()=>this.update());
    this.resizeObserver.observe(track);
    this.update();
  }
  get step() { return this.track.firstElementChild.getBoundingClientRect().width + 20; }
  move(direction) {
    const max = this.track.scrollWidth-this.track.clientWidth;
    const current = this.track.scrollLeft;
    let target = Math.max(0,Math.min(max,Math.round(current/this.step)*this.step+direction*this.step));
    let wrap=false;
    if(this.hasAttribute('data-loop')) {
      if(direction>0 && current>=max-2) { target=0; wrap=true; }
      if(direction<0 && current<=2) { target=max; wrap=true; }
    }
    this.track.scrollTo({left:target,behavior:wrap || matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  update() {
    if(!this.track?.firstElementChild) return;
    const max=this.track.scrollWidth-this.track.clientWidth;
    const loop=this.hasAttribute('data-loop');
    this.prev.hidden=this.next.hidden=max<2;
    this.prev.disabled=!loop && this.track.scrollLeft<2;
    this.next.disabled=!loop && this.track.scrollLeft>=max-2;
    if(this.dots) {
      const pages=Math.max(1,Math.ceil(max/this.step-.01)+1);
      if(this.dots.children.length!==pages) this.dots.replaceChildren(...Array.from({length:pages},()=>document.createElement('span')));
      const active=this.track.scrollLeft>=max-2?pages-1:Math.round(this.track.scrollLeft/this.step);
      [...this.dots.children].forEach((dot,i)=>dot.toggleAttribute('data-active',i===active));
    }
  }
}
customElements.define('product-recommendations',ProductRecommendations);
